/** 申报独立落地页 session 标记：外链进入后仅停留 /shen-bao */
const SESSION_KEY = 'n05:shenbao_solo'

function truthy(v) {
  const s = String(Array.isArray(v) ? v[0] : v || '')
    .trim()
    .toLowerCase()
  return s === '1' || s === 'true' || s === 'yes' || s === 'solo'
}

function firstQuery(v) {
  if (v == null) return ''
  return String(Array.isArray(v) ? v[0] : v).trim()
}

/** 同时读 route.query 与地址栏 search（入口域落地后 query 仍在） */
export function readLocationSearchParam(name) {
  try {
    return new URLSearchParams(window.location.search).get(name) || ''
  } catch {
    return ''
  }
}

/** 入口域会丢掉 pathname，但保留 hash：#/shen-bao */
export function readHashShenBaoPath() {
  try {
    const hash = String(window.location.hash || '')
    if (!hash || hash === '#') return ''
    const path = hash.replace(/^#/, '').split('?')[0]
    return path === '/shen-bao' || path.startsWith('/shen-bao/') ? '/shen-bao' : ''
  } catch {
    return ''
  }
}

/** 路由上是否带独立落地参数 */
export function hasShenBaoSoloQuery(route) {
  if (route?.query && (truthy(route.query.solo) || truthy(route.query.landing))) {
    return true
  }
  return truthy(readLocationSearchParam('solo')) || truthy(readLocationSearchParam('landing'))
}

/** session 是否已锁定独立模式 */
export function isShenBaoSoloSession() {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1'
  } catch {
    return false
  }
}

/** 当前是否处于申报独立落地页模式（query / hash / session） */
export function isShenBaoSolo(route) {
  return (
    hasShenBaoSoloQuery(route) ||
    !!readHashShenBaoPath() ||
    isShenBaoSoloSession()
  )
}

/** 是否应放行到申报页（路由守卫用，优先于登录校验） */
export function shouldOpenShenBaoPublic(route) {
  if (route?.path === '/shen-bao') return true
  return isShenBaoSolo(route)
}

/** 拼申报页 query：保留 ref / cb / invitation 等 */
export function buildShenBaoPublicQuery(route) {
  const q = { solo: '1' }
  const ref =
    firstQuery(route?.query?.ref) ||
    firstQuery(route?.query?.share_code) ||
    firstQuery(route?.query?.referrer_code) ||
    readLocationSearchParam('ref') ||
    readLocationSearchParam('share_code') ||
    readLocationSearchParam('referrer_code')
  const cb = firstQuery(route?.query?.cb) || readLocationSearchParam('cb')
  if (ref) q.ref = ref
  if (cb) q.cb = cb
  return q
}

/** 进入独立模式后写入 session，刷新仍锁定 */
export function enterShenBaoSolo() {
  try {
    sessionStorage.setItem(SESSION_KEY, '1')
  } catch {
    // ignore
  }
}

/** 站内底栏进入时清除，恢复可跳转其它页 */
export function clearShenBaoSolo() {
  try {
    sessionStorage.removeItem(SESSION_KEY)
  } catch {
    // ignore
  }
}

/**
 * 申报公开落地链接（直达业务域 /shen-bao，不经入口过渡页）。
 * 过渡页会丢掉 path/solo，入口域 /shen-bao?solo=1 会落到首页被踢登录；分享请用本函数。
 */
export function buildShenBaoLandingUrl({
  origin = typeof window !== 'undefined' ? window.location.origin : '',
  ref = '',
  cb = '',
} = {}) {
  const base = String(origin || '').replace(/\/$/, '')
  if (!base) return ''
  const params = new URLSearchParams({ solo: '1' })
  const code = String(ref || '').trim()
  const gateCb = String(cb || '').trim()
  if (code) params.set('ref', code)
  if (gateCb) params.set('cb', gateCb)
  return `${base}/shen-bao?${params.toString()}`
}
